import { GrupoEconomicoService } from './../../services/grupo-economico/grupo-economico.service';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService, PerfilService } from 'src/app/services';
import { Subscription } from 'rxjs';
import { IToken } from 'src/app/interfaces/token/IToken';
import { IGrupoEconomico } from 'src/app/interfaces';
import { ListaPaginada } from 'src/app/models';

@Component({
  selector: 'app-modal-cadastrar-perfil',
  templateUrl: './modal-cadastrar-perfil.component.html',
  styleUrls: ['./modal-cadastrar-perfil.component.scss']
})
export class ModalCadastrarPerfilComponent implements OnInit, OnDestroy {
  @Output() registerPerfil = new EventEmitter();
  @ViewChild('modal') template: TemplateRef<any>;
  subscriptions$ = new Subscription();
  cadastraForm!: FormGroup;
  grupoObrigatorio!: FormGroup;
  perfilInterno: boolean;
  gruposEconomicos = new ListaPaginada<IGrupoEconomico>();
  token: IToken = this.authenticationService.obterToken();

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private perfilService: PerfilService,
    private authenticationService: AuthenticationService,
    private grupoEconomicoService: GrupoEconomicoService
  ) {}

  ngOnInit(): void {
    this.cadastraForm = this.fb.group(
      {
        descricao: ['', [Validators.required]],
        nome: ['', [Validators.required]],
        condition: [false],
        grupoEc: ['', this.conditionalValidator()],
        perfilInterno: [false]
      },
      { validators: this.conditionalValidator() }
    );
    this.getGrupoEconomico();
  }
  conditionalValidator() {
    return (control) => {
      if (this.token?.tipoUsuario == 'EXT' || !this.perfilInterno) {
        return Validators.required(control);
      }
      return null;
    };
  }
  mostrarGruposEconomicos() {
    this.perfilInterno = !this.perfilInterno;
    this.cadastraForm.get('grupoEc')?.updateValueAndValidity();
  }
  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
  criarPerfil() {
    this.subscriptions$.add(
      this.perfilService
        .postPerfil({
          idUsuario: this.token?.id,
          codGrupoEconomico:
            this.token?.tipoUsuario == 'EXT' || !this.perfilInterno
              ? this.cadastraForm.get('grupoEc')?.value
              : null,
          nome: this.cadastraForm.get('nome')?.value,
          descricao: this.cadastraForm.get('descricao')?.value,
          perfilInterno:
            this.token?.tipoUsuario == 'EXT'
              ? (this.perfilInterno = false)
              : this.cadastraForm.get('perfilInterno')?.value
        })
        .subscribe({
          complete: () => {
            this.registerPerfil.emit();
            this.fecharModal();
          }
        })
    );
    // window.location.reload();
  }

  getGrupoEconomico() {
    this.subscriptions$.add(
      this.grupoEconomicoService
        .getGrupoEconomicos({
          idUsuario: Number(this.token.id),
          paginar: false
        })
        .subscribe(({ data }) => {
          this.gruposEconomicos = data;
        })
    );
  }

  abrirModal() {
    this.perfilInterno = false;
    this.ngOnInit();
    this.modalService.open(this.template, {
      centered: true,
      size: 'lg'
    });
  }

  fecharModal() {
    this.modalService.dismissAll();
  }
}
